import { memo } from "react";

import { Loader2 } from "lucide-react";

type SpinnerProps = {
  className?: string;
  colorClassName?: string;
  strokeWidth?: number;
};

const Spinner = ({
  className = "absolute inset-0",
  colorClassName = "text-brand-cyan h-5 w-5",
  strokeWidth = 3.5,
}: SpinnerProps) => {
  return (
    <div className={`flex items-center justify-center ${className}`}>
      <Loader2
        className={`animate-spin duration-700 ${colorClassName}`}
        strokeWidth={strokeWidth}
      />
    </div>
  );
};

export default memo(Spinner);
